import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'
import { AuthAPI } from '../../api/AuthAPI';
import { useLocation, useNavigate } from "react-router-dom";
import ReCAPTCHA from 'react-google-recaptcha';
import resetPassImg from '../../assets/images/rotate.png'
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import PopUpAlert from "../../component/PopUpAlert";

const ResetPassword = () => {
    const [data, setData] = useState({});
    const [error, setError] = useState("")
    const [success, setSuccess] = useState(false)
    const [errors, setErrors] = useState({ newPassword: false, confirmationCode: false })
    const [isLoading, setIsLoading] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [message, setMessage] = useState({ type: '', content: '' });
    const [passwordValidate, setPasswordValidate] = useState({ length: false, specialSymbal: false, number: false, upperLetter: false });
  
    const location = useLocation();
    let stateObj = location?.state;

    const navigate = useNavigate();
    
    const handleData = (event) => {
        setErrors({});
        const { name, value } = event.target;

        const uppercasePattern = /[A-Z]/;
        const specialCharPattern = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@$*])[A-Za-z0-9!@$*]{8,}$/;
        const numberPattern = /[0-9]/;
        let template = {}
        if (uppercasePattern.test(value)) {
          template.upperLetter = true;
        }
        if (specialCharPattern.test(value)) {
          template.specialSymbal = true;
        }
        if (numberPattern.test(value)) {
          template.number = true;
        }
        if (value?.length >= 8) {
          template.length = true;
        }
        setPasswordValidate(template);
        setData({ ...data, [name]: value });
    }



    const validate = async () => {

      setMessage({ type: '', content: '' });

        let errorFields = {};
       
  
        if (!data.confirmationCode?.trim()) {
            errorFields.confirmationCode = true;
        }
        if (!passwordValidate.length || !passwordValidate.number || !passwordValidate.specialSymbal || !passwordValidate.upperLetter) {
            errorFields.newPassword = true;
          }

        if (!data.newPassword?.trim()) {
            errorFields.newPassword = true;
        }
      
        setErrors(errorFields);
        if (!stateObj?.userEmail?.trim() || !data.confirmationCode?.trim() || !data.newPassword?.trim() ||
            !passwordValidate.length || !passwordValidate.number || !passwordValidate.specialSymbal || 
            !passwordValidate.upperLetter  
        ) {
             return;
        }

        try {

            const resetPasswordData = {
                userName: stateObj?.userEmail,
                confirmationCode: data.confirmationCode,
                newPassword: data.newPassword
            }

           
            await AuthAPI.confirmResetPassword(resetPasswordData)
            setSuccess(true)
            navigate("/login", { replace: true });
        } catch (err) {
            setMessage({ type: 'error', content: err?.response?.data?.Data });
            setError(err.message)
        }
    }

   
    const verifyCaptcha = async (data) => {
        try {
            const response = await AuthAPI.postVerifyCaptcha(data);
            setCaptchaVerified(response.Data);
        } catch (error) {

        }
    }
    if (success) {
        return (
            <div>
              
                <h2>Reset password</h2>
                <p>Your password has been reset successfully!</p>
            </div>
        )
    }
    return (

        <div>
             <PopUpAlert type={message.type} message={message.content} />
        <div className='reset_password_container'>
            <div className='reset_password_form'>
                <div className='reset_password_heading'>
                    <img src={resetPassImg} alt="" />
                    <h2>Let us help you to reset</h2>
                </div>
                <TextField
                    error={errors.confirmationCode}
                    helperText={errors.confirmationCode && "Confirmation code is required"}
                    onChange={handleData}
                    value={data.confirmationCode || ''}
                    name='confirmationCode'
                    className='reset_pass_text_input'
                    variant='outlined'
                    label="Confirmation Code" />

                <TextField
                    error={errors.newPassword}
                    helperText={errors.newPassword && "New password is required"}
                    onChange={handleData}
                    value={data.newPassword || ''}
                    name='newPassword'
                    className='reset_pass_text_input'
                    variant='outlined'
                    label="new Password" />
 
        <div className="password_validate_message_box">
            <p className={passwordValidate.upperLetter ?
              "password_validate_message active" :
              (!passwordValidate.upperLetter && errors.newPassword) ? "password_validate_message error" : "password_validate_message"}>
              <IoMdCheckmarkCircleOutline className="password_validate_log" />Require at least 1 Uppercase</p>
            <p className={passwordValidate.specialSymbal ?
              "password_validate_message active" :
              (!passwordValidate.specialSymbal && errors.newPassword) ? "password_validate_message error" : "password_validate_message"}>
              <IoMdCheckmarkCircleOutline className="password_validate_log" />Must include exactly one of: ! @ $ * (no other special characters)</p>
            <p className={passwordValidate.number ?
              "password_validate_message active" :
              (!passwordValidate.number && errors.newPassword) ? "password_validate_message error" : "password_validate_message"}>
              <IoMdCheckmarkCircleOutline className="password_validate_log" />Require at least 1 Number</p>
            <p className={passwordValidate.length ?
              "password_validate_message active" :
              (!passwordValidate.length && errors.newPassword) ? "password_validate_message error" : "password_validate_message"}>
              <IoMdCheckmarkCircleOutline className="password_validate_log" />Minimum 8 Characters</p>
          </div>
                <ReCAPTCHA
                    style={{alignSelf:'center'}}
                    className="re-captcha"
                    sitekey={`${import.meta.env.VITE_APP_CAPTCHA_SITE_KEY}`}
                    onChange={(data) => verifyCaptcha(data)}
                />
                <div className='reset_password_submit_btn'>
                    <Button disabled={!captchaVerified} onClick={validate} fullWidth variant='contained'>Submit</Button>
                </div>
            </div>
        </div>
        </div>
    )
}

export default ResetPassword